import type React from 'react';

import { Translate, TranslateHtml, useI18n } from '@change-corgi/core/react/i18n';
import { Link } from '@change-corgi/design-system-legacy/components/actions';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { ReportType } from '../shared/types';

type Props = {
	type: ReportType;
};

export const Footer: React.FC<Props> = ({ type }) => {
	const { translate } = useI18n();

	const notice = translate(`fe.components.${type}_report_abuse.notice`, {
		tosUrl: '',
		cgUrl: '',
	});

	// for some reason, sometimes the i18n label contains the <a> tag, sometimes not...
	if (!notice.includes('<a')) {
		return (
			<Text as="div" size="caption" sx={{ textAlign: 'center' }} mt={16}>
				<TranslateHtml
					value={`fe.components.${type}_report_abuse.notice`}
					// TODO process the generated links into @change-corgi/core Link?
					replacements={{
						tosUrl: (
							<Link to="/policies/terms-of-service">
								<Translate value="fe.pages.terms_of_service.title" />
							</Link>
						),
						cgUrl: (
							<Link to="/policies/community">
								<Translate value="fe.pages.community_guidelines.title" />
							</Link>
						),
					}}
				/>
			</Text>
		);
	}

	return (
		<Text as="div" size="caption" sx={{ textAlign: 'center' }} mt={16}>
			<TranslateHtml
				value={`fe.components.${type}_report_abuse.notice`}
				// TODO process the generated links into @change-corgi/core Link?
				replacements={{
					tosUrl: '/policies/terms-of-service',
					cgUrl: '/policies/community',
				}}
			/>
		</Text>
	);
};
